import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=a6ecd0f4&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&lang=less&"
import style1 from "./invite.vue?vue&type=style&index=1&id=a6ecd0f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ecd0f4",
  null
  
)

export default component.exports